import { HttpErrorsType } from '../../application/protocols/http-client';
import { type DomainException } from './domain-exception';

export class BlockedUserException implements DomainException {
  message = HttpErrorsType.BLOCKED_USER_EXCEPTION;
  code = 'Error';
}
